import React from "react";
import { ProductCard } from "../Search/SearchCard";
import { DISPLAYMODE } from "../Search/SearchToolbar/DisplayMode";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { renderSuperscriptDagger } from "../../helpers/TextFormatting";
import "./SavedProductsCard.scss";

function SavedProductsCard({ product, labels, productImageHeight, productImageWidth, displayMode = DISPLAYMODE.GRIDCOMPACT, modalContainerRef, positionModal }) {
  const sendDataToGTM = useGTMDispatch();
  const {
    useForLabel = "",
  } = window.globalProperties;

  const isActiveProduct = product["publishStatus"]?.toString().toLowerCase() !== "inactive";

  const handleDetailClick = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    sendDataToGTM({
      event: "viewDetails",
      productName: product["childProductName"],
      productID: product.productCode,
    });
    // Navigate after GTM event
    if (product.url) {
      window.location.href = product.url;
    }
  };

  // Format product data for ProductCard
  const formattedProduct = {
    ...product,
    contentType: "product",
    catalogImage: product.catalogImage,
    childProductName: product.childProductName,
    productCode: product.productCode,
    isPrintable: product.isPrintable,
    isEmbossable: product.isEmbossable,
    isNewProduct: product.isNewProduct,
    isProPlanet: product.isProPlanet,
  };

  const temperatureUsageValues = Array.isArray(product["temperatureUsageCatalogFilter"])
    ? product["temperatureUsageCatalogFilter"]
    : [product["temperatureUsageCatalogFilter"]];

  // Render additional product info (temperature usage, item count)
  const renderAdditionalInfo = () => (
    <>
      {product["temperatureUsageCatalogFilter"]?.length > 0 && (
        <p className="product-card__product-body description-count">
          <span>{useForLabel}: </span>
          <span>
            {temperatureUsageValues.map((value, index) => (
              <React.Fragment key={`temperature-usage-${index}`}>
                {index > 0 && ", "}
                {renderSuperscriptDagger(value, `temperature-usage-${index}`)}
              </React.Fragment>
            ))}
          </span>
        </p>
      )}

      {product["effectiveUnitsPerCase"] && (
        <p className="product-card__product-body description-count">
          <span>{labels["itemCountLabel"]}: </span>
          <span>{product["effectiveUnitsPerCase"]}</span>
        </p>
      )}
    </>
  );

  return (
    <div className="saved-products-card">
      <ProductCard
        product={formattedProduct}
        productImageHeight={productImageHeight}
        productImageWidth={productImageWidth}
        displayMode={displayMode}
        externalModalDiv={displayMode === DISPLAYMODE.GRIDCOMPACT && modalContainerRef ? modalContainerRef.current : null}
        positionModal={positionModal}
        isDiscontinued={!isActiveProduct}
        discontinuedLabel={labels["discontinuedLabel"]}
        discontinuedMessage={labels["discontinuedDescription"]}
        renderAdditionalInfo={renderAdditionalInfo}
        onCtaClick={handleDetailClick}
      />
    </div>
  );
}

export default SavedProductsCard;
